'use strict';

require('./RoomService');
var log = require('../../log/Log').channel('LightingController');
var sutl = require('../../sutl/Sutl');
var defaults = require('../../defaults/Defaults');
var DimmerControlsExtension = require('./DimmerControlsExtension');
require('./PresetButtonDirective');
require('./RoomService');
require('./SelectMenuPositionService');

angular
    .module('inara')

    .directive('shadeControl', function () {
        // Directive defining buttons for shade controls
        return {
            restrict: 'E',
            templateUrl: 'shadeControl.html',
            scope: {
                control: '<',
                controlLabel: '<',
                getControlIcon: '<',
                onControlRelease: '<',
                onControlTouch: '<',
                isControlDisabled: '<',
                preserveEmptyControls: '<',
            },
        };
    })

    .controller('LightingController', LightingController);

LightingController.$inject = [
    '$scope',
    '$state',
    '$timeout',
    'ionicMaterialInk',
    'KayleeService',
    'RoomService',
    '$ionicPopover',
    'SelectMenuPositionService',
    '$ionicPosition',
    '$ionicScrollDelegate',
    '$q',
    'gettextCatalog',
    '$window',
    'IosTouchEventService',
];

function LightingController(
    $scope,
    $state,
    $timeout,
    ionicMaterialInk,
    KayleeService,
    RoomService,
    $ionicPopover,
    SelectMenuPositionService,
    $ionicPosition,
    $ionicScrollDelegate,
    $q,
    gettextCatalog,
    $window,
    IosTouchEventService
) {
    var vm = this;
    var room = null;

    var lightingPresetIcons = {
        light_off: 'ion-aveo-lightbulb-off',
        lectern: 'ion-aveo-lectern',
        ceiling_light: 'ion-aveo-ceiling-light',
        globe_light: 'ion-aveo-globe-light',
        light_group: 'ion-aveo-lightbulb-group',
        light: 'ion-aveo-lightbulb',
        light_on: 'ion-aveo-lightbulb-on',
        meeting: 'ion-aveo-room',
        seat: 'ion-aveo-seat',
        teaching: 'ion-aveo-teach',
        theater: 'ion-aveo-theater',
        wall_sconce: 'ion-aveo-wall-sconce',
        wall_sconce_round: 'ion-aveo-wall-sconce-round',
    };
    var shadeIcons = {
        arrow_up_circle: 'ion-aveo-arrow-up-circle',
        arrow_down_circle: 'ion-aveo-arrow-down-circle',
        stop_circle: 'ion-aveo-stop-circle',
        increase_circle: 'ion-android-add-circle',
        decrease_circle: 'ion-android-remove-circle',
        shade_arrow_up: 'ion-aveo-shades-arrow-up',
        shade_arrow_down: 'ion-aveo-shades-arrow-down',
        shade_open: 'ion-aveo-shades-open',
        shade_closed: 'ion-aveo-shades-closed',
        shade_half_open: 'ion-aveo-shades-half-open',
        shade_tilt_increase: 'ion-aveo-shades-tilt-increase',
        shade_tilt_decrease: 'ion-aveo-shades-tilt-decrease',
        shade_tilt_increase_alt: 'ion-aveo-shades-tilt-increase-alt',
        shade_tilt_decrease_alt: 'ion-aveo-shades-tilt-decrease-alt',
        shade_vertical_arrow_left: 'ion-aveo-shades-vertical-arrow-left',
        shade_vertical_arrow_right: 'ion-aveo-shades-vertical-arrow-right',
        shade_vertical_open: 'ion-aveo-shades-vertical-open',
        shade_vertical_closed: 'ion-aveo-shades-vertical-closed',
        shade_vertical_half_open: 'ion-aveo-shades-vertical-half-open',
    };
    var shadePresetIcons = shadeIcons;

    var presetRunningDuration = 1500; // time in ms for running indicator
    var lightingPresetUiStates = {};
    var shadePresetUiStates = {};
    var prevLightingControls = null;
    var prevShadeControls = null;
    var prevLightingPresets = null;
    var prevShadePresets = null;

    log.info('initializing');

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });
    var wrappedShadeHandlers = IosTouchEventService.wrapHandlers(onShadeControl, onShadeControl);

    vm.anyLightingControlHasDimmer = anyLightingControlHasDimmer;
    vm.anyShadeControlHasStop = anyShadeControlHasStop;
    vm.lightingControlUiStates = {};
    vm.formatDimmer = formatDimmer;
    vm.getLightingPresetIcon = getLightingPresetIcon;
    vm.getShadeControlIcon = getShadeControlIcon;
    vm.getShadePresetIcon = getShadePresetIcon;
    vm.hasDimmer = hasDimmer;
    vm.hasLightingControls = hasLightingControls;
    vm.hasShadeControls = hasShadeControls;
    vm.isLightingControlDisabled = isLightingControlDisabled;
    vm.isLightingPresetRunning = isLightingPresetRunning;
    vm.isLightingPresetSelected = isLightingPresetSelected;
    vm.isShadeControlDisabled = isShadeControlDisabled;
    vm.isShadePresetRunning = isShadePresetRunning;
    vm.isShadePresetSelected = isShadePresetSelected;
    vm.lightingPresetsCount = lightingPresetsCount;
    vm.onSelectLightingPreset = onSelectLightingPreset;
    vm.onSelectShadePreset = onSelectShadePreset;
    vm.onShadeControlRelease = wrappedShadeHandlers.onRelease;
    vm.onShadeControlTouch = wrappedShadeHandlers.onTouch;
    vm.onShowDimmerControls = onShowDimmerControls;
    vm.shadePresetsCount = shadePresetsCount;

    angular.extend(
        vm,
        new DimmerControlsExtension(
            $scope,
            $ionicPopover,
            $timeout,
            $window,
            $ionicPosition,
            IosTouchEventService
        )
    );

    RoomService.onOnlineChanged(onRoomServiceOnlineChanged);
    $scope.$on('$stateChangeSuccess', onStateChange);

    $scope.$on('$ionicView.enter', function () {
        if (vm.hasLightingControls() || vm.hasShadeControls()) {
            $ionicScrollDelegate.$getByHandle('lighting-controls-scroll').scrollTop(false);
        }
        if (vm.lightingPresetsCount() > 0 || vm.shadePresetsCount() > 0) {
            $ionicScrollDelegate.$getByHandle('lighting-presets-scroll').scrollTop(false);
        }
    });

    $scope.$on('$destroy', function () {
        RoomService.offOnlineChanged(onRoomServiceOnlineChanged);

        vm.dimmercontrols.hideDimmerControls();
        if (room !== null) {
            room.$offChange(onRoomChanged);
            room = null;
            prevLightingControls = null;
            prevLightingPresets = null;
            prevShadeControls = null;
            prevShadePresets = null;
        }
    });

    function anyLightingControlHasDimmer() {
        var lightingControls = sutl.getNode(room, 'configuredCaps.lightingControls');
        if (lightingControls === null) return false;
        for (var key in lightingControls) {
            if (!lightingControls.hasOwnProperty(key)) continue;
            if (sutl.getNode(lightingControls[key], 'hasDimmer', false)) return true;
        }
        return false;
    }

    function anyShadeControlHasStop() {
        var shadeControls = sutl.getNode(room, 'configuredCaps.shadeControls');
        if (shadeControls === null) return false;
        for (var key in shadeControls) {
            if (!shadeControls.hasOwnProperty(key)) continue;
            if (sutl.getNode(shadeControls[key], 'position.actions.stop') !== null) return true;
            if (sutl.getNode(shadeControls[key], 'tilt.actions.stop') !== null) return true;
        }
        return false;
    }

    function createGetterSetter(roomFnName, roomFnParam, initValue) {
        var _value = initValue;
        return function (value, deviceUpdate) {
            if (arguments.length > 0) {
                _value = value; // set local value immediately
                if (!deviceUpdate && RoomService.online()) {
                    if (angular.isDefined(roomFnParam)) {
                        room[roomFnName](roomFnParam, value);
                    } else {
                        room[roomFnName](value);
                    }
                }
            }
            return _value;
        };
    }

    function formatDimmer(control) {
        if (!vm.lightingControlUiStates[control.$key].power()) {
            return '';
        } else {
            var dimmer = vm.lightingControlUiStates[control.$key].dimmer();
            return (dimmer ? dimmer : 0) + '%';
        }
    }

    function getLightingPresetIcon(preset) {
        if (!preset || !preset.icon || !lightingPresetIcons.hasOwnProperty(preset.icon)) {
            return '';
        }
        return lightingPresetIcons[preset.icon];
    }

    function getShadeControlIcon(icon) {
        if (!icon || !shadeIcons.hasOwnProperty(icon)) return '';
        return shadeIcons[icon];
    }

    function getShadePresetIcon(preset) {
        if (!preset || !preset.icon || !shadePresetIcons.hasOwnProperty(preset.icon)) {
            return '';
        }
        return shadePresetIcons[preset.icon];
    }

    function hasDimmer(control) {
        return sutl.getNode(
            room,
            ['configuredCaps', 'lightingControls', control.$key, 'hasDimmer'],
            false
        );
    }

    function hasLightingControls() {
        var lightingControls = sutl.getNode(room, 'configuredCaps.lightingControls');
        return lightingControls !== null && Object.keys(lightingControls).length > 0;
    }

    function hasShadeControls() {
        var shadeControls = sutl.getNode(room, 'configuredCaps.shadeControls');
        if (shadeControls !== null) {
            for (var key in shadeControls) {
                if (!shadeControls.hasOwnProperty(key)) continue;
                if (
                    (shadeControls[key].showPositionControls && shadeControls[key].position) ||
                    (shadeControls[key].showTiltControls && shadeControls[key].tilt)
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    function initializeUiStates(items, uiStates, initFunction) {
        if (Object.keys(items).length === 0 && Object.keys(uiStates).length > 0) {
            uiStates = {};
        }
        for (var key in items) {
            if (!items.hasOwnProperty(key)) continue;
            if (!uiStates.hasOwnProperty(key)) {
                uiStates[key] = {};
                initFunction(uiStates, key);
            }
        }
        for (key in uiStates) {
            if (!uiStates.hasOwnProperty(key)) continue;
            if (!items.hasOwnProperty(key)) {
                // remove old UI state for a non-existent item
                delete uiStates[key];
            }
        }
        return uiStates;
    }

    function isLightingPresetRunning(preset) {
        return lightingPresetUiStates[preset.$key].running;
    }

    function isLightingPresetSelected(preset) {
        return lightingPresetUiStates[preset.$key].selected;
    }

    function isLightingControlDisabled(lightingControlId) {
        if (!RoomService.online()) return true;
        return (
            sutl.getNode(room, ['configuredCaps', 'lightingControls', lightingControlId]) !==
                null && sutl.getNode(room, ['caps', 'lightingControls', lightingControlId]) === null
        );
    }

    function isShadeControlDisabled(shadeControlId) {
        if (!RoomService.online()) return true;
        return (
            sutl.getNode(room, ['configuredCaps', 'shadeControls', shadeControlId]) !== null &&
            sutl.getNode(room, ['caps', 'shadeControls', shadeControlId]) === null
        );
    }

    function isShadePresetRunning(preset) {
        return shadePresetUiStates[preset.$key].running;
    }

    function isShadePresetSelected(preset) {
        return shadePresetUiStates[preset.$key].selected;
    }

    function lightingPresetsCount() {
        var presets = sutl.getNode(room, 'configuredCaps.lightingPresets');
        return presets !== null ? Object.keys(presets).length : 0;
    }

    function onRoomChanged() {
        if (!RoomService.online()) return;

        var key;
        var presets = sutl.getNode(room, 'configuredCaps.lightingPresets');

        if (prevLightingPresets === null || !sutl.objEquals(prevLightingPresets, presets)) {
            prevLightingPresets = angular.copy(presets);
            vm.lightingPresets = prevLightingPresets ? angular.copy(prevLightingPresets) : {};
            lightingPresetUiStates = initializeUiStates(
                vm.lightingPresets,
                lightingPresetUiStates,
                function (uiStates, key) {
                    uiStates[key].running = false;
                }
            );
        }

        for (key in lightingPresetUiStates) {
            if (!lightingPresetUiStates.hasOwnProperty(key)) continue;
            lightingPresetUiStates[key].selected = sutl.getNode(
                room,
                ['states', 'lightingPresets', key, 'active'],
                false
            );
        }

        presets = sutl.getNode(room, 'configuredCaps.shadePresets');

        if (prevShadePresets === null || !sutl.objEquals(prevShadePresets, presets)) {
            prevShadePresets = angular.copy(presets);
            vm.shadePresets = prevShadePresets ? angular.copy(prevShadePresets) : {};
            shadePresetUiStates = initializeUiStates(
                vm.shadePresets,
                shadePresetUiStates,
                function (uiStates, key) {
                    uiStates[key].running = false;
                }
            );
        }

        for (key in shadePresetUiStates) {
            if (!shadePresetUiStates.hasOwnProperty(key)) continue;
            shadePresetUiStates[key].selected = sutl.getNode(
                room,
                ['states', 'shadePresets', key, 'active'],
                false
            );
        }

        var lightingControlsChanged = false;
        var shadeControlsChanged = false;
        var lightingControls = sutl.getNode(room, 'configuredCaps.lightingControls');

        if (
            prevLightingControls === null ||
            !sutl.objEquals(prevLightingControls, lightingControls)
        ) {
            lightingControlsChanged = true;
            vm.dimmercontrols.hideDimmerControls();
            prevLightingControls = angular.copy(lightingControls);
            vm.lightingControls = prevLightingControls ? angular.copy(prevLightingControls) : {};
            vm.lightingControlUiStates = initializeUiStates(
                vm.lightingControls,
                vm.lightingControlUiStates,
                function (uiStates, key) {
                    uiStates[key].power = createGetterSetter('$requestLightingPower', key, false);
                    uiStates[key].dimmer = createGetterSetter('$requestLightingLevel', key, 0);
                }
            );
        }

        for (key in vm.lightingControlUiStates) {
            if (!vm.lightingControlUiStates.hasOwnProperty(key)) continue;
            vm.lightingControlUiStates[key].power(
                sutl.getNode(room, ['states', 'lightingControls', key, 'power'], false),
                true
            );
            vm.lightingControlUiStates[key].dimmer(
                sutl.getNode(room, ['states', 'lightingControls', key, 'level'], 0),
                true
            );
        }

        var shadeControls = sutl.getNode(room, 'configuredCaps.shadeControls');

        if (prevShadeControls === null || !sutl.objEquals(prevShadeControls, shadeControls)) {
            shadeControlsChanged = true;
            prevShadeControls = angular.copy(shadeControls);
            vm.shadeControls = prevShadeControls ? angular.copy(prevShadeControls) : {};
        }

        if (
            $state.current.name === 'control.lighting' &&
            (lightingControlsChanged || shadeControlsChanged)
        ) {
            var scrollDelegate = $ionicScrollDelegate.$getByHandle('lighting-controls-scroll');
            if (scrollDelegate) scrollDelegate.resize();
        }
    }

    function onRoomServiceOnlineChanged(online) {
        if (online) {
            room = RoomService.getRoom();
            room.$onChange(onRoomChanged);
        } else if (room !== null) {
            room.$offChange(onRoomChanged);
            room = null;
            prevLightingControls = null;
            prevLightingPresets = null;
            prevShadeControls = null;
            prevShadePresets = null;
        }
    }

    function onSelectLightingPreset(preset) {
        onSelectPreset(preset, 'lighting');
    }

    function onSelectPreset(preset, type) {
        if (!RoomService.online()) return;
        log.debug('selected ' + type + ' preset: ' + preset.name);

        var uiStates;
        if (type === 'lighting') {
            uiStates = lightingPresetUiStates;
        } else if (type === 'shade') {
            uiStates = shadePresetUiStates;
        } else {
            throw new Error('Unknown preset type: ' + type);
        }

        for (var key in uiStates) {
            // reset any other presets running states
            if (key !== preset.$key) {
                uiStates[key].running = false;
                if (angular.isDefined(uiStates[key].runningTimeout)) {
                    $timeout.cancel(uiStates[key].runningTimeout);
                    delete uiStates[key].runningTimeout;
                }
            }
        }

        uiStates[preset.$key].running = true;
        if (angular.isDefined(uiStates[preset.$key].runningTimeout)) {
            $timeout.cancel(uiStates[preset.$key].runningTimeout);
        }
        uiStates[preset.$key].runningTimeout = $timeout(function () {
            uiStates[preset.$key].running = false;
            delete uiStates[preset.$key].runningTimeout;
        }, presetRunningDuration);
        if (type === 'lighting') {
            room.$requestLightingPreset(preset.$key);
        } else if (type === 'shade') {
            room.$requestShadePreset(preset.$key);
        } else {
            throw new Error('Unknown preset type: ' + type);
        }
    }

    function onSelectShadePreset(preset) {
        onSelectPreset(preset, 'shade');
    }

    function onShadeControl($event, shadeControlId, command, action, event) {
        if (!RoomService.online()) return;
        var fnName = '$requestShade' + command[0].toUpperCase() + command.substr(1);
        log.info(
            'onShadeControl: ' + fnName + '(' + shadeControlId + ', ' + action + ', ' + event + ')'
        );
        room[fnName](shadeControlId, action, event);
    }

    function onShowDimmerControls(control, $event) {
        vm.dimmercontrols.showDimmerControls(room, control.$key, $event);
    }

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (toState.name !== 'control.lighting') {
            vm.dimmercontrols.hideDimmerControls();
        }
    }

    function shadePresetsCount() {
        var presets = sutl.getNode(room, 'configuredCaps.shadePresets');
        return presets !== null ? Object.keys(presets).length > 0 : 0;
    }
}

module.exports = LightingController;
